import { render } from "./CardMediumPI.vue?vue&type=template&id=0b7826ad"
import script from "./CardMediumPI.vue?vue&type=script&lang=js"
export * from "./CardMediumPI.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__